import script from "./AdminActivityEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminActivityEdit.vue?vue&type=script&setup=true&lang=js"

import "./AdminActivityEdit.vue?vue&type=style&index=0&id=08b970ad&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08b970ad"]])

export default __exports__